module.exports = __webpack_public_path__ + "static/balance-gold-5b86cdf850baeb2a5d59bd7508316d8e.png";